import { EnumCacheEntityType } from "@/app/services/generated/enums/enumCacheEntityType.generated";
import type { CommunicationType } from "@/app/services/generated/communicationtypeService";
import { communicationTypeService } from "@/app/services/generated/communicationtypeService";
import {
  EntityWithGuidKeyCache,
  EntityCacheStore,
} from "@/app/caching/apiCache";

// Singleton cache store
const communicationTypesCacheStore = new EntityCacheStore<CommunicationType>(
  EnumCacheEntityType.communicationType,
  async () => communicationTypeService.getAllCommunicationTypes()
);

// Ephemeral reader
export default class CommunicationTypesCache extends EntityWithGuidKeyCache<CommunicationType> {
  constructor() {
    super(communicationTypesCacheStore, (x) => x.id);
  }
}
